import axios from "axios";
import { BASE_URL_API } from "constants/constants";
import { checkTokenExpiration } from "contexts/TokenCheck";

export async function getListPicklistAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "picklist/load_listview_picklist", data, {
    headers: {
      Authorization: token,
    },
  });
}

export async function getPicklistAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "picklist/load_listview_picklist", data, {
    headers: {
      Authorization: token,
    },
  });
}

export async function createPicklistAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "picklist/create-object-picklist", data, {
    headers: {
      Authorization: token,
    },
  });
}

export async function editPickListAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "picklist/edit-picklist", data, {
    headers: {
      Authorization: token,
    },
  });
}

export async function editParentPickListAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "picklist/update-parent-picklist", data, {
    headers: {
      Authorization: token,
    },
  });
}

export async function actionOptionPickListAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "picklist/action-picklist", data, {
    headers: {
      Authorization: token,
    },
  });
}

export async function deltePickListAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "picklist/delete-picklist", data, {
    headers: {
      Authorization: token,
    },
  });
}

export async function addOptionAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "picklist/add-option-picklist", data, {
    headers: {
      Authorization: token,
    },
  });
}

export async function getFieldSubAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "picklist/load-subscriber-picklist", data, {
    headers: {
      Authorization: token,
    },
  });
}
